import { useBalance } from "@/hooks/useBalance";
import { Button } from "../ui/button";
import { useModal } from "@/hooks/useModal";
import { Gift } from 'lucide-react'
import { centsToPrettyDollars } from "@skillscratch/shared-util";
import { useEffect, useMemo } from "react";
import { ErrorModal } from "./ErrorModal";



export function PromoBalanceModal() {
    const { closeModal, openModal } = useModal();

    const [userData, isUserDataLoading, userDataError] = useBalance();


    const stringifiedBalance = useMemo(() => {
        return userData?.balance !== undefined ? centsToPrettyDollars(userData?.balance) : "$0.00";
    }, [userData?.balance]);

    const stringifiedPromoBalance = useMemo(() => {
        return userData?.promoBalance !== undefined ? centsToPrettyDollars(userData?.promoBalance) : "$0.00";
    }, [userData?.promoBalance])

    // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
    useEffect(() => {
        if (userDataError) {
            openModal(<ErrorModal message={userDataError.message}/>);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userDataError]);

    return (
        <div className="bg-white rounded-xl shadow-lg py-8 px-2 w-80 text-blue-dark">
            <h1 className="text-3xl font-semibold text-center">Your balances</h1>
            <div className="flex space-y-6 flex-col pb-8 pt-8 mx-4">
                <div>
                    <h2 className='text-2xl font-semibold mb-2'>
                        $ Cash - {isUserDataLoading ? "$--.--" : stringifiedBalance}
                    </h2>
                    <p className='text-lg font-medium'>
                        Use it to buy cards or make withdrawals
                    </p>
                </div>
                <div>
                    <h2 className='text-2xl font-semibold mb-2 flex flex-row items-center gap-1'>
                        <Gift />
                        Promo Cash - {isUserDataLoading ? "$--.--" : stringifiedPromoBalance}
                    </h2>
                    <p className='text-lg font-medium'>
                        Use it only to buy cards, can't be withdrawn
                    </p>
                </div>
            </div>
            <div className="flex justify-end h-full mx-4">
                <Button 
                    className="py-6 bg-blue text-white text-2xl font-bold w-full rounded-lg flex items-center justify-center gap-3"
                    shine
                    onClick={() => closeModal()}
                >
                    Got it!
                </ Button>
            </div>
        </div>
    );
}